/**
 * `SHELL-043`/`A11Y-044`. Deliberately not `LeaveConfirmDialog`: that
 * dialog answers a back-navigation the player may not have meant (`SHELL-017`)
 * and its own copy promises the opposite of what this one does -- "your
 * progress will be saved so you can resume it later". Quitting is an
 * explicit, deliberate exit; `docs/prompts/sprint-5c.md`'s own stage 1 note
 * states the asymmetry plainly: a deliberate exit clears the save, an
 * unexpected one does not. Reusing the save-and-leave copy and its
 * persistence call here would have quit silently keep progress the
 * requirement says to discard -- caught before shipping, not after, by
 * writing this dialog's own copy rather than reaching for the nearest
 * existing one that merely looked similar.
 */

import { ConfirmDialog } from '@shell/ConfirmDialog';

export interface QuitConfirmDialogProps {
  onCancel: () => void;
  onConfirm: () => void;
}

export function QuitConfirmDialog({ onCancel, onConfirm }: QuitConfirmDialogProps) {
  return (
    <ConfirmDialog
      headingId="quit-confirm-heading"
      detailId="quit-confirm-detail"
      heading="Quit this level?"
      detail="Your current score, moves and progress toward its goals will be lost."
      cancelLabel="Stay"
      confirmLabel="Quit"
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
}
